import React, { useEffect, useState } from 'react';

import { motion } from 'framer-motion';

import { getProgressPercentage } from '@pkg/utils';

import { OutputBubble, type OutputBubbleProps } from '../../../OutputBubble';

import { characterLimitTransition, CharacterLimitVariant, characterLimitVariants } from './CharacterLimit.motion';
import './CharacterLimit.scss';

export interface CharacterLimitProps {
    limit: number;
    used: number;
    contributors: NonNullable<OutputBubbleProps['contributors']>;
}

export function CharacterLimit({ limit, used, contributors }: CharacterLimitProps) {
    const [remaining, setRemaining] = useState(limit);

    useEffect(() => {
        setRemaining(limit - used);
    }, [limit, used]);

    const progress = getProgressPercentage(limit - remaining, limit);

    return (
        <motion.div
            className="PlainTextEditor-CharacterLimit"
            variants={characterLimitVariants}
            initial={CharacterLimitVariant.Initial}
            animate={CharacterLimitVariant.Show}
            exit={CharacterLimitVariant.Initial}
            transition={characterLimitTransition}
        >
            <OutputBubble value={remaining} progress={progress} contributors={contributors} />
        </motion.div>
    );
}
